export enum TermEnd {
  BOTH_FROM_AND_TO = 0,
  FROM_ONLY = 1,
  TO_ONLY = 2,
}

export interface Term {
  colorSequenceNumber?: number;
  /** Wire description */
  description?: string;
  /** From block tag */
  fromBlockTag?: string;
  /** From code */
  fromCode?: string;
  /** From customer count */
  fromCustomerCount?: number;
  /** From equipment point id */
  fromEquipmentBlockPointId?: string;
  /** From equipment id */
  fromEquipmentId: string;
  /** From equipment tag */
  fromEquipmentTag?: string;
  /** From point tag */
  fromPointTag?: string;
  /** From side (VC) */
  fromSide?: string;
  /** From vendor count */
  fromVendorCount?: number;
  /** From wire number */
  fromWire?: string;
  /** Id */
  id: string;
  /** Cable or Jumper id */
  parentId: string;
  /** Project id */
  projectId: string;
  /** Wire sequence number */
  sequenceNumber: number;
  /** To block tag */
  toBlockTag?: string;
  /** To code */
  toCode?: string;
  /** To customer count */
  toCustomerCount?: number;
  /** To equipment point id */
  toEquipmentBlockPointId?: string;
  /** To equipment id */
  toEquipmentId: string;
  /** To equipment tag */
  toEquipmentTag?: string;
  /** To point tag */
  toPointTag?: string;
  /** To side (VC) */
  toSide?: string;
  /** To vendor count */
  toVendorCount?: number;
  /** To wire number */
  toWire?: string;

  /** Wire color */
  wireColor?: string;
}

export interface TermItem {
  colorSequenceNumber: number;
  description: string | null;
  fromCode: string | null;
  fromEquipmentBlockId: string | null;
  fromEquipmentBlockPointId: string | null;
  fromEquipmentId: string | null;
  fromSide: string | null;
  fromWire: string | null;
  id: string;
  parentId: string;
  projectId: string;
  sequenceNumber: number;
  toCode: string | null;
  toEquipmentBlockId: string | null;
  toEquipmentBlockPointId: string | null;
  toEquipmentId: string | null;
  toSide: string | null;
  toWire: string | null;
  wireColor: string | null;

  // Parent columns for grid row processing
  tag: string;
  isCableOrJumper: string;
  fromTermSecondaryStatus: string | null;
  toTermSecondaryStatus: string | null;
  fromTermEngrStatus: string | null;
  toTermEngrStatus: string | null;
  // View columns
  fromEquipmentTag: string | null;
  fromBlockTag: string | null;
  fromPointTag: string | null;
  fromVendorCount: number;
  fromCustomerCount: number;
  toEquipmentTag: string | null;
  toBlockTag: string | null;
  toPointTag: string | null;
  toVendorCount: number;
  toCustomerCount: number;
  isRestricted?: boolean;
}

export interface EquipmentCable {
  id: string;
  fromEquipmentId: string;
  fromEquipmentTag: string;
  tag: string;
  isCableOrJumper: string;
}
